@let commentsUnreadCount = commentsUnreadCount$ | async;

<div class="messages-panel">
  <div class="messages-panel_title">
    <p>{{ 'CHATS' | translate }}</p>
    <button mat-button class="actions-marked" (click)="markedAll()">
      {{ 'MARK ALL AS READ' | translate }}
    </button>
  </div>
  <div class="messages-panel_actions">
    <div class="actions--filter">
      <button
        class="actions-btn"
        [ngClass]="{ active: isActiveFilterType === null }"
        (click)="sortBy(null, false)">
        {{ 'ALL' | translate }}
      </button>

      <button
        class="actions-btn"
        [ngClass]="{
          active: isActiveFilterType === messageNotificationProgress.Unread
        }"
        (click)="sortBy(messageNotificationProgress.Unread, false)">
        {{ 'UNREAD' | translate }}
        <span>({{ commentsUnreadCount?.newMessageNotificationsCount }})</span>
      </button>
    </div>
  </div>

  <div class="messages-panel_content">
    @if (communicationChartsNotification.length > 0) {
      <cdk-virtual-scroll-viewport
        #viewport
        minBufferPx="720"
        maxBufferPx="920"
        itemSize="156"
        class="lists"
        (scrolledIndexChange)="onScroll()">
        <app-communication-panel-card
          *cdkVirtualFor="let notification of communicationChartsNotification"
          [notification]="notification"
          (deleteNotification)="deleteNotificationItem($event)"
          (notificationViewed)="
            notifyCommunication($event)
          "></app-communication-panel-card>
      </cdk-virtual-scroll-viewport>
    } @else {
      <div class="messages-attention">
        <nav class="not-access-image">
          <img src="../../../../../../../assets/svg/logo.svg" alt="Neolink" />
        </nav>
        <h3 class="not-access-title text">
          {{ 'NOTIFICATION NOT FOUND' | translate }}
        </h3>
      </div>
    }
  </div>
</div>
<div class="messages-overlay" (click)="closePanel.emit()"></div>
